import { Directive, Input, OnDestroy, OnInit } from "@angular/core";
import { NgControl } from "@angular/forms";
import { Subscription } from "rxjs";

import { FormatNumber } from "../services/FormatNumber";

@Directive({
  selector: "[medFormatNubmer]",
})
export class MedNumberPatternDirective implements OnInit, OnDestroy {
  constructor(private ngControl: NgControl) { }

  private _subscription?: Subscription;

  @Input() medFormatNubmer = false;
  @Input() medFormatNubmerPrecision?: number;

  ngOnInit() {
    this._handle();
  }

  ngOnDestroy() {
    this._subscription?.unsubscribe();
  }

  private _handle() {
    this._subscription = this.ngControl.control?.valueChanges.subscribe(data => {
      if (!this.medFormatNubmer || !data) {
        return;
      }

      const formatted = new FormatNumber(data, this.medFormatNubmerPrecision).number;

      this.ngControl.control?.setValue(formatted, { emitEvent: false });
    });
  }
}
